import DOMPurify from 'dompurify';

export const sanitizeDescription = (value) => DOMPurify.sanitize(value || '', {
  ALLOWED_TAGS: ['p','br','strong','b','em','i','u','s','h1','h2','h3','h4','h5','h6','ul','ol','li','blockquote','span','div','hr'],
  ALLOWED_ATTR: ['style'],
});

export function safeWebsite(value) {
  if (typeof value !== 'string' || /[\s<>\\]/.test(value)) return undefined;
  try {
    const url = new URL(/^[a-z][a-z0-9+.-]*:/i.test(value) ? value : `https://${value}`);
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password && url.hostname.includes('.') ? url.href : undefined;
  } catch { return undefined; }
}

